import { FC, ReactNode } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { Provider } from "react-redux"
import { persistStore } from "redux-persist"
import { PersistGate } from "redux-persist/integration/react"

import CustomSnackbarProvider from "~/components/snackbar/CustomSnackbarProvider"
import { store } from "~/store/store"
import AppTheme from "~/theme/AppTheme"

import "../../sentry"

interface IProviders {
  children: ReactNode
}

const Providers: FC<IProviders> = ({ children }) => {
  const persistor = persistStore(store)

  const client = new QueryClient({
    defaultOptions: {
      queries: {
        // keepPreviousData: true,
        retry: false,
        // staleTime: 10000
      },
    },
  })
  return (
    <QueryClientProvider client={client}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppTheme>
            <CustomSnackbarProvider>
              {children}

              <ReactQueryDevtools initialIsOpen={false} />
            </CustomSnackbarProvider>
          </AppTheme>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  )
}

export default Providers
